<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <router-link class="btn btn-dark" :to="{ name: 'inventario-ajuste_inventario' }">
            <i class="fa fa-arrow-left sliding-icon"></i>
            Regresar
          </router-link>
          <br><br>
          <div class="element-wrapper">
            <div class="element-box">
              <div class="st-meta float-right">
                <div class="element-actions">
                  <div class="btn-group">
                    <button aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle"
                      data-toggle="dropdown" type="button">
                      <i class="fa fa-cogs"></i>
                      Acciones
                    </button>
                    <div class="dropdown-menu dropdown-menu-right">
                      <button class="dropdown-item" :class="{ disabled: !(current.estado == 'B') }" @click="abrir"
                        :disabled="true" href="#">
                        <i class="fa fa-unlock"></i>&nbsp;
                        Abrir Operación
                      </button>
                      <button class="dropdown-item" @click="cerrar()" :disabled="!(current.estado == 'A')">
                        <i class="fa fa-lock"></i>&nbsp;
                        Finalizar Operación
                      </button>
                      <button class="dropdown-item" @click="generar_ajuste_conteo()" href="#"
                        :disabled="!(current.ajusteinventariod_set == '')">
                        <i class="fa fa-check"></i>&nbsp;
                        Generar desde Conteo
                      </button>
                      <div class="dropdown-divider"></div>
                      <button :disabled="current.estado == 'A'" class="dropdown-item" @click="imprimir">
                        <i class="fa fa-print"></i>&nbsp;
                        Imprimir Constancia
                      </button>
                      <div class="dropdown-divider"></div>
                      <button class="dropdown-item" @click="anular" :disabled="true" href="#" style="color: #ff7777;">
                        <i class="fa fa-trash"></i>&nbsp;
                        Anular Operación
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <br><br>
              <form @submit="guardar">
                <h5 class="form-header">
                  <div style="text-align: center">
                    Ajuste de Inventario #{{ current.numero }}
                    <br>
                    <div class="badge" :class="{
                      'badge-success': current.estado == 'A',
                      'badge-warning': current.estado == 'B',
                      'badge-danger': current.estado == '9',
                    }">
                      <i class="os-icon os-icon-ui-09"></i>
                      <span v-if="current.estado_str">{{ current.estado_str }}</span>
                      <span v-if="!current.estado_str">En Proceso</span>
                    </div>
                  </div>
                  <br>
                </h5>
                <small v-if="current.errors && current.errors.detail" class="form-text text-danger">{{
                  current.errors.detail }}</small>
                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label v-bind:class="{
                        'text-danger':
                          current.errors.tienda && current.errors.tienda.length > 0,
                      }">Tienda</label>
                      <select class="form-control" autofocus="autofocus" v-model="current.tienda"
                        :disabled="current.estado != 'A'">
                        <option v-for="(tienda, key) in tiendas" :value="tienda.codigo" :key="key">
                          {{ tienda.nombre }}
                        </option>
                      </select>
                      <small v-if="current.errors && current.errors.tienda" class="form-text text-danger">{{
                        current.errors.tienda[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      {{ critero_ajuste }}
                      <label v-bind:class="{
                        'text-danger': current.errors && current.errors.critero_ajuste,
                      }">Criterio</label>
                      <select class="form-control" autofocus="autofocus" v-model="current.critero_ajuste"
                        :disabled="current.estado != 'A'" @change="refreshSubcriteroAjuste()">
                        <option v-for="(det, key) in criteros_ajuste" :value="det.codigo" :key="key">
                          {{ det.codigo }} -
                          {{ det.descripcion }}
                        </option>
                      </select>
                      <small v-if="current.errors.critero_ajuste && current.errors" class="form-text text-danger">{{
                        current.errors.critero_ajuste }}</small>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label v-bind:class="{
                        'text-danger':
                          current.errors && current.errors.sub_critero_ajuste,
                      }">Subcriterio Ajuste</label>
                      <select class="form-control" autofocus="autofocus" v-model="current.sub_critero_ajuste"
                        :disabled="current.estado != 'A'">
                        <option v-for="(det, key) in subcriterios" :value="det.codigo" :key="key">
                          {{ det.codigo }} -
                          {{ det.descripcion }}
                        </option>
                      </select>
                      <small v-if="current.errors && current.errors.sub_critero_ajuste" class="form-text text-danger">{{
                        current.errors.sub_critero_ajuste }}</small>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-6">
                    <div class="form-group">
                      <label>Motivo de Ajuste</label>
                      <input v-model="current.motivo_ajuste" autofocus="autofocus" class="form-control"
                        placeholder="Motivo de Ajuste" type="text" :disabled="current.estado != 'A'" />
                      <small v-if="current.errors && current.errors.motivo_ajuste" class="form-text text-danger">{{
                        current.errors.motivo_ajuste[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label v-bind:class="{
                        'text-danger':
                          current.errors.fecha && current.errors.fecha.length > 0,
                      }">Fecha</label>
                      <input v-model="current.fecha" class="form-control" placeholder="Fecha" :disabled="true"
                        type="text" />
                      <small v-if="current.errors && current.errors.fecha" class="form-text text-danger">{{
                        current.errors.fecha[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label>Usuario</label>
                      <input :disabled="true" class="form-control" v-model="current.usuario" type="text" />
                    </div>
                  </div>
                  <div class="col-sm-11">
                    <div class="form-group">
                      <label class="switch" id="por_conteo_switch">
                        <input class="text-center" type="checkbox" v-model="checked" />
                        <span class="slider-button"></span>
                      </label>
                      <label> &nbsp; Ajuste de inventario por conteo</label>
                    </div>
                  </div>
                  <div>
                    <button class="btn btn-md btn-primary" v-if="current.estado != 'B'" type="submit">
                      Guardar &nbsp;
                      <i class="fas fa-check"></i>
                    </button>
                  </div>
                </div>
                <div>
                  <br />
                  <button type="button" class="btn btn-md btn-block btn-dark" @click="showModalAddDetail"
                    v-if="current.estado == 'A' && current.id && checked == false">
                    <i class="fa fa-plus"></i>
                    Agregar Producto
                  </button>
                  <button v-if="checked == true && current.estado == 'A' && current.id" type="button"
                    class="btn btn-md btn-block btn-primary" data-toggle="modal" data-target="#modalAddConteoE">
                    <i class="fa fa-plus"></i>
                    Agregar detalle por conteo
                  </button>
                </div>
                <hr />
                <div v-if="checked == false">
                  <h5>Resumen de Ajuste</h5>
                  <br />
                  <div class="invoice-table" v-if="current.id != null">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>SKU</th>
                          <th>Producto</th>
                          <th>Lote</th>
                          <th>Posición</th>
                          <th class="text-center" style="width: 100px">Unidades</th>
                          <th class="text-center" v-if="current.estado == 'A'">Opciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="detalle in current.ajusteinventariod_set" v-bind:key="detalle.id">
                          <td>{{ detalle.producto.sku }}</td>
                          <td>{{ detalle.producto.nombre }}</td>
                          <td>
                            {{ detalle.producto_lote.codigo_lote }}
                          </td>
                          <td>
                            {{ detalle.tienda_posicion.posicion }} - {{ detalle.tienda_posicion.descripcion }}
                          </td>
                          <td class="text-right bolder nowrap" style="font-weight: 500">
                            <span v-if="current.estado == 'B'">
                              {{ detalle.cantidad }}</span>
                            <div class="input-group input-group-sm" v-if="current.estado == 'A'">
                              <div class="input-group-prepend"></div>
                              <input v-if="current.estado == 'A'" class="form-control text-right"
                                v-model="detalle.cantidad" placeholder="cantidad" type="text" />
                              <div class="input-group-append"></div>
                            </div>
                          </td>
                          <td class="text-center" style="width: 100px" v-if="current.estado == 'A'">
                            <button class="btn btn-sm btn-success" type="button" @click="ModificarDetalle(detalle)">
                              <i class="far fa-save"></i>
                            </button>
                            <button class="btn btn-sm btn-danger" type="button" @click="eliminarDetalle(detalle)">
                              <i class="fas fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <!-------------------- END - Basic Table -------------------->
                  </div>
                </div>
                <div v-if="checked == true">
                  <h5>Conteos agrupados agregados al ajuste</h5>
                  <br />
                  <div class="invoice-table" v-if="current.id != null">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th class="text-center">Número</th>
                          <th class="text-center">Usuario</th>
                          <th class="text-center">Tienda</th>
                          <th class="text-center">Fecha</th>
                          <th class="text-center">Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="detalle in current.invaplicacionajusteconteo_set" v-bind:key="detalle.id">
                          <td class="text-center">{{ detalle.Conteoe_set.numero }}</td>
                          <td class="text-center">
                            {{ detalle.Conteoe_set.usuario.name }}
                          </td>
                          <td class="text-center">
                            {{ detalle.Conteoe_set.tienda_obj.nombre }}
                          </td>
                          <td class="text-center">{{ detalle.Conteoe_set.fecha }}</td>
                          <td class="text-center">
                            <router-link class="btn btn-sm btn-success" :to="{
                              name: 'inventario-conteo-editar',
                              params: { id: detalle.Conteoe_set.id },
                            }">
                              <i class="fas fa-share"></i>
                            </router-link>
                            <button @click="eliminarDetalleConteo(detalle.Conteoe_set.id)"
                              class="btn btn-sm btn-danger">
                              <i class="fas fa-times"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <!-------------------- END - Basic Table -------------------->
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div aria-hidden="true" class="modal fade" id="modalAddConteoE" role="dialog" tabindex="-1" data-backdrop="static"
      data-keyboard="false">
      <div class="modal-dialog modal-xl" role="document" style="max-width: 75%">
        <div class="modal-content modal-xl" style="max-width: 75%">
          <div class="modal-header">
            <h5 class="modal-title">Agregar conteo agrupado</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-5">
                <label>Fecha de Conteo</label>
                <input class="form-control form-control-sm" placeholder="Fecha Conteo" type="date"
                  v-model="filter.fecha" id="input_fecha" />
              </div>
              <div class="col-5">
                <label>Número identificador</label>
                <input class="form-control form-control-sm" placeholder="Conteo #123" type="text"
                  v-model="filter.numero" id="input_conteo2" />
              </div>
              <div class="col-2">
                <br />
                <button @click="refreshConteo()" class="btn btn-md btn-success" type="button">
                  <i class="fa fa-search"></i>
                </button>
                &nbsp;
                <button class="btn btn-md btn-dark" type="button" @click="undo()">
                  <i class="fas fa-undo"></i>
                </button>
              </div>
            </div>
            <hr />
            <div>
              <br />
              <div class="invoice-table">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th class="text-center">Identificador</th>
                      <th class="text-center">Tienda</th>
                      <th class="text-center">Fecha</th>
                      <th class="text-center">Usuario</th>
                      <th class="text-center">opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="detalle in dataTabla" v-bind:key="detalle.id">
                      <td class="text-center">{{ detalle.identificador }}</td>
                      <td class="text-center">{{ detalle.tienda_obj.nombre }}</td>
                      <td class="text-center">
                        {{ detalle.fecha_creacion | moment("DD/MM/YYYY hh:mm a") }}
                      </td>
                      <td class="text-center">{{ detalle.usuario.name }}</td>
                      <td class="text-center">
                        <br />
                        <button @click="agregarConteo(detalle)" class="btn btn-success btn-md">
                          Agregar conteo <i class="fas fa-plus"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-------------------- END - Basic Table -------------------->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div aria-hidden="true" class="modal fade" id="modalAddDetailReqTraslado" role="dialog" tabindex="-1">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Agregar Producto</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-sm-12 mb-1">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        currentDetalle.errors.producto &&
                        currentDetalle.errors.producto.length > 0,
                    }">Producto</label>
                    <v-select label="nombre" v-model="currentDetalle.producto" :filterable="false" :options="productos"
                      @search="onSearchProducto" @input="setSelected">
                      <template slot="no-options">Producto...</template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          <img :src="option.image" />
                          {{ option.sku }} - {{ option.nombre }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          <img :src="option.image" />
                          {{ option.sku }} - {{ option.nombre }}
                        </div>
                      </template>
                    </v-select>
                    <small v-if="currentDetalle.errors && currentDetalle.errors.producto"
                      class="form-text text-danger">{{
                        currentDetalle.errors.producto[0] }}</small>
                  </div>
                </div>
                <div class="col-sm-12 mb-1">
                  Lotes:
                  <select v-model="currentDetalle.codigo_lote" v-if="
                    currentDetalle.productolote_set != null &&
                    currentDetalle.productolote_set.length > 0
                  " class="form-control" autofocus="autofocus">
                    <option v-for="detalle in currentDetalle.productolote_set" :value="detalle.id"
                      v-bind:key="detalle.id">
                      Lote: {{ detalle.codigo_lote }} || Vence:
                      {{ detalle.fecha_vence }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-6 mb-1">
                  Bodega:
                  <select v-model="busqueda_posicion.bodega_id" class="form-control" @change="changeBodega"
                    autofocus="autofocus">
                    <option v-for="detalle in bodegas" :value="detalle.id" v-bind:key="detalle.bodega">
                      {{ detalle.bodega }} - {{ detalle.descripcion }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-6 mb-1">
                  Seccion:
                  <select v-model="busqueda_posicion.seccion_id" class="form-control" @change="changeSeccion"
                    autofocus="autofocus">
                    <option v-for="detalle in secciones" :value="detalle.id" v-bind:key="detalle.seccion">
                      {{ detalle.seccion }} - {{ detalle.descripcion }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-6 mb-1">
                  Rack:
                  <select v-model="busqueda_posicion.rack_id" class="form-control" @change="changeRack"
                    autofocus="autofocus">
                    <option v-for="detalle in racks" :value="detalle.id" v-bind:key="detalle.rack">
                      {{ detalle.rack }} - {{ detalle.descripcion }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-6 mb-1">
                  Nivel:
                  <select v-model="busqueda_posicion.nivel_id" class="form-control" @change="changeNivel">
                    <option v-for="detalle in niveles" :value="detalle.id" v-bind:key="detalle.nivel">
                      {{ detalle.nivel }} - {{ detalle.descripcion }}
                    </option>
                  </select>
                </div>

                <div class="col-sm-6 mb-1">
                  Posicion:
                  <select v-model="currentDetalle.posicion" class="form-control">
                    <option v-for="detalle in posiciones" :value="detalle.posicion_id" v-bind:key="detalle.id">
                      {{ detalle.codigo_barra }}
                    </option>
                  </select>
                  <small v-if="currentDetalle.errors && currentDetalle.errors.posicion" class="form-text text-danger">{{
                    currentDetalle.errors.posicion }}</small>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        currentDetalle.errors.cantidad &&
                        currentDetalle.errors.cantidad.length > 0,
                    }">Cantidad en Unidades</label>
                    <input v-model="currentDetalle.cantidad" class="form-control" placeholder="Cantidad" type="text"
                      style="text-align: center; font-size: 200%" v-bind:class="{
                        'is-invalid':
                          currentDetalle.errors.cantidad &&
                          currentDetalle.errors.cantidad.length > 0,
                      }" />
                    <small v-if="currentDetalle.errors && currentDetalle.errors.cantidad"
                      class="form-text text-danger">{{
                        currentDetalle.errors.cantidad }}</small>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <small class="form-text text-danger" v-if="currentDetalle.errors" > 
                      {{currentDetalle.errors.detail}}
                    </small>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="agregaDetalle" type="button">
              Agregar <i class="fas fa-check"></i>
            </button>
            <button class="btn btn-danger" ref="cerrarModal" data-dismiss="modal" type="button">
              Cancelar <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import CommonService from "@/services/commons/CommonService";
import ProductosService from "@/services/catalogos/ProductosService";
import PosicionesService from "@/services/inventario/PosicionesService";
import DynamicService from "@/services/commons/DynamicService";
import AjusteInventarioService from "@/services/inventario/AjusteInventarioService";
import Notifications from "@/notifications/notifications";

export default {
  components: {},
  data() {
    return {
      dataTabla: [],
      checked: "",
      filter: {
        numero: "",
        fecha: "",
      },
      current: {
        id: null,
        estado_str: null,
        tienda: "",
        fecha: "01/01/2019",
        estado: "A",
        motivo_ajuste: "",
        errors: [],
        critero_ajuste: "",
        sub_critero_ajuste: "",
      },
      subcriterios: "",
      productos: [],
      posiciones: [],
      options: [],
      producto_lote: [],

      bodegas: [],
      secciones: [],
      racks: [],
      niveles: [],
      det: {
        descripcion: "",
        codigo: "",
      },
      critero_ajuste: "",
      sub_critero_ajuste: "",

      busqueda_posicion: {
        bodega_id: null,
        seccion_id: null,
        rack_id: null,
        posicion_id: null,
      },
      currentDetalle: {
        cantidad: 0,
        posicion: "",
        producto: "",
        codigo_lote: 0,
        productolote_set: [],
        errors: [],
      },
      criteros_ajuste: [],
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
    fecha_str: function () {
      let self = this;
      return self.customFormatter(self.current.fecha);
    },
  },
  mounted() {
    let self = this;
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
      self.formatoFecha();
    });
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
    this.refreshcriteroAjuste();
    if (this.current.critero_ajuste) {
      this.refreshSubcriteroAjuste();
    }
  },
  methods: {
    eliminarDetalleConteo(detalle) {
      let self = this;
      DynamicService.postAction(
        "inv",
        "ajuste_inventario",
        self.current.id,
        "eliminar_conteo_detalle",
        { id: detalle }
      )
        .then((response) => {
          Notifications.alert.success(
            "eliminar conteo del ajuste",
            "Realizado con éxito."
          );
          self.refreshCurrent();
          self.refreshDetalleDefault();
        })
        .catch((error) => {
          Notifications.alert.error(
            "eliminar conteo del ajuste",
            error.response.data.detail
          );
          self.currentDetalle.errors = error.response.data;
        });
    },
    agregarConteo(det) {
      let self = this;
      DynamicService.postAction(
        "inv",
        "ajuste_inventario",
        self.current.id,
        "agregar_linea_conteo",
        { id: det.id }
      )
        .then((response) => {
          Notifications.alert.success("Agregar conteo al ajuste", "Realizado con éxito.");
          self.refreshCurrent();
          self.refreshDetalleDefault();
          $("#modalAddConteoE").modal("hide");
          this.undo();
        })
        .catch((error) => {
          Notifications.alert.error(
            "Agregar conteo al ajuste",
            error.response.data.detail
          );
          console.log(error.response.data);
          self.currentDetalle.errors = error.response.data;
        });
    },
    refreshConteo() {
      if (this.filter.fecha) {
        this.fecha = moment(this.filter.fecha).format("DD/MM/YYYY");
      }
      DynamicService.fetch("inv", "conteo-agrupado", {
        fecha: this.fecha,
        tienda: this.current.tienda,
        identificador: this.filter.numero,
      }).then((response) => {
        this.dataTabla = response.data.results;
      });
    },
    refreshSubcriteroAjuste() {
      DynamicService.getById(
        "inv",
        "inv_criterio_ajuste",
        this.current.critero_ajuste
      ).then((response) => {
        this.subcriterios = response.data.subcriterioajuste_set;
      });
    },
    refreshcriteroAjuste() {
      DynamicService.fetch("inv", "inv_criterio_ajuste").then((response) => {
        this.criteros_ajuste = response.data.results;
      });
    },
    formatoFecha() {
      let self = this;
      self.current.fecha = self.current.fecha.replace(/\//g, "-");
    },
    setSelected(value) {
      let self = this;
      ProductosService.getById(value.sku).then((res) => {
        self.currentDetalle.productolote_set = res.data.productolote_set;
        self.currentDetalle.codigo_lote = res.data.productolote_set[0].id;
      });
      self.refreshBodegas();
    },
    refreshCurrent() {
      let self = this;
      AjusteInventarioService.getById(this.$route.params.id).then((response) => {
        self.current = response.data;
        self.current.usuario = response.data.usuario.name;
        self.current.tienda = response.data.tienda.codigo;
        self.current.fecha = self.customFormatter(self.current.fecha);
        self.current.errors = [];
        self.currentDetalle.errors = [];
        self.currentDetalle.cantidad = 0;
        if (self.current.critero_ajuste) {
          this.refreshSubcriteroAjuste();
        }
      });
    },
    undo() {
      let self = this;
      self.filter = [];
      self.dataTabla = [];
    },
    refreshBodegas() {
      let self = this;
      DynamicService.fetch("cat", "tienda-bodega", {
        tienda: self.current.tienda,
        quitar_paginacion: true,
      }).then((res) => {
        self.bodegas = res.data;
        if (self.busqueda_posicion.bodega_id == null) {
          self.busqueda_posicion.bodega_id = self.bodegas[0].id;
          this.refreshSecciones();
        }
      });
    },
    changeBodega() {
      this.refreshSecciones();
    },
    changeSeccion() {
      this.refreshRacks();
    },
    changeRack() {
      this.refreshNiveles();
    },
    changeNivel() {
      this.refreshPosiciones();
    },
    refreshSecciones() {
      let self = this;
      DynamicService.fetch("cat", "tienda-seccion", {
        tienda: self.current.tienda,
        bodega: self.busqueda_posicion.bodega_id,
        quitar_paginacion: true,
      }).then((res) => {
        self.secciones = res.data;
        if (self.busqueda_posicion.seccion_id == null) {
          self.busqueda_posicion.seccion_id = self.secciones[0].id;
          this.refreshRacks();
        }
      });
    },
    refreshPosiciones() {
      let self = this;
      let params = {
        page: 1,
        tienda: self.current.tienda,
        quitar_paginacion: true,
      };
      if (self.busqueda_posicion.bodega_id) {
        params.bodega_id = self.busqueda_posicion.bodega_id;
      }
      if (self.busqueda_posicion.seccion_id) {
        params.seccion_id = self.busqueda_posicion.seccion_id;
      }
      if (self.busqueda_posicion.rack_id) {
        params.rack_id = self.busqueda_posicion.rack_id;
      }
      if (self.busqueda_posicion.nivel_id) {
        params.nivel_id = self.busqueda_posicion.nivel_id;
      }
      PosicionesService.fetch(params).then((res) => {
        self.posiciones = res.data;
        if (self.busqueda_posicion.posicion_id == null) {
          self.currentDetalle.posicion = self.posiciones[0].id;
        }
      });
    },
    refreshRacks() {
      let self = this;
      DynamicService.fetch("cat", "tienda-rack", {
        tienda: self.current.tienda,
        seccion: self.busqueda_posicion.seccion_id,
        quitar_paginacion: true,
      }).then((res) => {
        self.racks = res.data;
        if (self.busqueda_posicion.rack_id == null) {
          self.busqueda_posicion.rack_id = self.racks[0].id;
          this.refreshNiveles();
        }
      });
    },
    refreshNiveles() {
      let self = this;
      DynamicService.fetch("cat", "tienda-nivel", {
        tienda: self.current.tienda,
        rack: self.busqueda_posicion.rack_id,
        quitar_paginacion: true,
      }).then((res) => {
        self.niveles = res.data;
        if (self.busqueda_posicion.nivel_id == null) {
          self.busqueda_posicion.nivel_id = self.niveles[0].id;
          this.refreshPosiciones();
        }
      });
    },

    guardar(e) {
      e.preventDefault();
      let self = this;
      let current = Object.assign({}, self.current);
      current.fecha = self.current.fecha.replace(/\//g, "-");
      current.tienda = self.current.tienda;
      AjusteInventarioService.save(current)
        .then((response) => {
          if (current.id == null) {
            self.$router.push({
              name: "inventario-ajuste_inventario-editar",
              params: { id: response.data.id },
            });
            Notifications.alert.success("Ajuste de Inventario", "Guardado Correctamente");
            self.refreshCurrent();
          }
        })
        .catch((error) => {
          self.current.errors = error.response.data;
        });
    },
    onSearchPosicion(search, loading) {
      loading(true);
      this.searchPosicion(loading, search, this);
    },

    searchPosicion: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);

        return;
      }
      let self = this;
      let params = {
        page: 1,
        tienda: vm.current.tienda,
        quitar_paginacion: true,
        "filter[search]": search,
      };
      if (self.busqueda_posicion.bodega_id) {
        params.bodega_id = self.busqueda_posicion.bodega_id;
      }
      if (self.busqueda_posicion.seccion_id) {
        params.seccion_id = self.busqueda_posicion.seccion_id;
      }
      if (self.busqueda_posicion.rack_id) {
        params.rack_id = self.busqueda_posicion.rack_id;
      }
      if (self.busqueda_posicion.nivel_id) {
        params.nivel_id = self.busqueda_posicion.nivel_id;
      }

      PosicionesService.fetch(params).then((res) => {
        vm.posiciones = res.data;
        loading(false);
      });
    }, 350),

    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    onSearchProducto(search, loading) {
      loading(true);
      this.searchProducto(loading, search, this);
    },

    searchProducto: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      ProductosService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.productos = res.data;
        loading(false);
      });
    }, 350),

    customFormatter(date) {
      var d = date.toString().split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];

      return moment(str_d).format("DD/MM/YYYY");
    },
    showModalAddDetail() {
      let self = this;
      ProductosService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then((res) => {
        self.productos = res.data.results;
      });
      PosicionesService.fetch({
        page: 1,
        tienda: self.current.tienda,
        activo: true,
      }).then((res) => {
        self.posiciones = res.data.results;
      });
      $("#modalAddDetailReqTraslado").modal();
    },

    agregaDetalle() {
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      if (det.producto) {
        det.producto = det.producto.sku;
      }
      if (det.codigo_lote) {
        det.producto_lote = det.codigo_lote;
      }
      AjusteInventarioService.agregarDetalle(self.current.id, det)
        .then((response) => {
          Notifications.alert.success(
            "Ajuste de Inventario",
            "Se ha guardado la Información."
          );
          self.refreshCurrent();
          self.refreshDetalleDefault();
          self.$refs.cerrarModal.click();
        })
        .catch((error) => {
          console.log(error.response.data);
          self.currentDetalle.errors = error.response.data;
        });
    },

    eliminarDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Ajuste de Inventario",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          AjusteInventarioService.eliminarDetalle(self.current.id, {
            id: detalle.id,
          })
            .then((response) => {
              Notifications.alert.success(
                "Ajuste Inventario",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;
            });
        }
      );
    },
    ModificarDetalle(detalle) {
      let self = this;
      AjusteInventarioService.editarDetalle(self.current.id, detalle)
        .then((response) => {
          Notifications.alert.success("Información", "Guardado Correctamente");
          self.refreshCurrent();
        })
        .catch((error) => {
          self.current.errors = error.response.data;
        });
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Ajuste de Inventario",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          AjusteInventarioService.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Ajuste de Inventario",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Abrir Transaccion", error.response.data.detail);
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "¿Está seguro que desea finalizar?",
        "Ya no podrá abrir, ni anular el documento.",
        "",
        function () {
          AjusteInventarioService.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "¡Hecho!",
                "Ajuste finalizado con éxito."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Error", error.response.data.detail);
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Anular",
        "¿Está seguro que quiere dar de baja?",
        "Si Anular",
        function () {
          AjusteInventarioService.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "¡Ajuste anulado!",
                "Se dió de baja a la transacción."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Anular Transaccion", error.response.data.detail);
            });
        }
      );
    },
    refreshDetalleDefault() {
      let self = this;
      self.currentDetalle = {
        cantidad: 0,
        cantidad_um: 0,
        unidad_medida: null,
        producto: {
          sku: null,
          unidad_medida: null,
          errors: [],
        },
        errors: [],
      };
    },
    imprimir() {
      let op;
      op = this.$route.params.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=inventario/ajuste_inventario/AjusteInventario.jrxml&id=${op}`
      );
    },
    generar_ajuste_conteo() {
      let self = this;
      Notifications.alert.confirm(
        "Generar Ajuste",
        "¿Desea Continuar?",
        "Si, generar",
        function () {
          AjusteInventarioService.generar_ajuste_desde_conteo(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Ajuste Generado",
                "Se añadió el detalle de Conteos."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Generar Ajuste", error.response.data.detail);
            });
        }
      );
    },
  },
};
</script>
